import { apiRequest } from './httpClient';

export async function resolveAuthUserSession() {
  return apiRequest('resolveAuthUserSession', {
    method: 'POST',
    body: {},
    requireAuth: true,
  });
}
